import React, { useEffect } from 'react';
import type { OAuthResult } from './vcs-connection-modal-form-oauth-authorization-button';
import VcsConnectionModalFormOauthAuthorizationButton from './vcs-connection-modal-form-oauth-authorization-button';
import { Row } from 'components/common/grid';
import { Typography } from 'antd';
import { BridgedAlert as Alert } from 'components/common/feedback/bridged-alert';
import { FormattedMessage } from 'react-intl';
import type { VcsConnectionsForm } from './access-card/use-connection-modal-access-card-form.hook';

export const VcsConnectionModalFormOauth: React.FC<VcsConnectionsForm> = ({
  vcsConnection,
  form,
  onTokenProcessingChange
}) => {
  const [oauthResult, setOauthResult] = React.useState<OAuthResult>({});

  const [, setAuthorizationId] = form.useManualField('authorizationId');
  const [, setTokenId] = form.useManualField('tokenId');

  useEffect(() => {
    if (oauthResult.error) {
      setAuthorizationId(undefined);
      setTokenId(undefined);
    } else if (oauthResult.tokenId) {
      setTokenId(oauthResult.tokenId);
      setAuthorizationId(undefined);
    } else if (oauthResult.authorizationId) {
      setAuthorizationId(oauthResult.authorizationId);
      setTokenId(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthResult]);

  return (
    <>
      <Row style={{ marginBottom: '7px' }}>
        <Alert
          type="warning"
          message={
            <FormattedMessage id="organization.settings.agents.vcs-connections-modal.connection.oauth.warning" />
          }
        />
      </Row>
      <Row>
        <VcsConnectionModalFormOauthAuthorizationButton
          connectionType={vcsConnection.connectionType}
          vcsType={vcsConnection.type}
          onClosed={setOauthResult}
          onTokenProcessingChange={onTokenProcessingChange}
          accessScope={vcsConnection.accessScope}
        />
      </Row>
      <Row style={{ marginBottom: '4px' }}>
        {oauthResult.error && (
          <Typography.Text strong underline type={'danger'}>
            <FormattedMessage
              id="organization.settings.agents.vcs-connections-modal.connection.oauth.failed"
              values={{ message: oauthResult.error }}
            />
          </Typography.Text>
        )}
        {oauthResult.accessScope && (
          <Typography.Text strong underline type={'success'}>
            <FormattedMessage
              id="organization.settings.agents.vcs-connections-modal.connection.oauth.success"
              values={{ accessScope: oauthResult.accessScope }}
            />
          </Typography.Text>
        )}
      </Row>
    </>
  );
};
